const environment = process.env.ENV;

var locations = {};

switch (environment) {
    case 'dev':
        locations.apiDomain = 'api.dashweb-olp-dev.webteam.qq.opendns.com';
        locations.apiv3Host = 'http://api.dashweb-olp-dev.webteam.qq.opendns.com';
        locations.dash2 = 'http://dashboard2.dashweb-olp-dev.webteam.qq.opendns.com/#overview';
        break;
    case 'test':
        locations.apiDomain = 'api.dashweb-olp-test.webteam.qq.opendns.com';
        locations.apiv3Host = 'http://api.dashweb-olp-test.webteam.qq.opendns.com';
        locations.dash2 = 'http://dashboard2.dashweb-olp-test.webteam.qq.opendns.com/#overview';
        break;
    default:
        locations = {
            apiDomain: 'api.opendns.com',
            apiv3Host: 'https://api.opendns.com',
            dash2: 'https://dashboard.umbrella.com/#overview',
        };
}

module.exports = locations;



// WEBPACK FOOTER //
// ./config/locations.js